var map = {
	"./dev/config.json": 1855,
	"./prod/config.json": 1856,
	"./qa/config.json": 1857,
	"./qa2/config.json": 1858,
	"./sandbox-partner/config.json": 1859,
	"./sandbox/config.json": 1860,
	"./uat/config.json": 1861,
	"./uat2/config.json": 1862,
	"./uat3/config.json": 1863
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1854;